module.exports = __webpack_public_path__ + "static/media/21ECLAC34.4c50ed06.jpg";